
























import { defineComponent, PropType } from '@nuxtjs/composition-api';

export enum ActivePriceFilterTypes {
  CHECKBOXES = 'checkboxes',
  RANGE = 'range',
  QUICK_FILTER = 'quick-filter'
}

export default defineComponent({
  name: 'PriceFilter',
  props: {
    selected: {
      type: Object as PropType<any>,
      default: null
    },
    minPrice: {
      type: Number,
      required: true
    },
    maxPrice: {
      type: Number,
      required: true
    },
    activeFilterType: {
      type: String,
      required: false
    }
  },
  setup(props, { emit }) {
    const updateSliderRange = ({ min, max }: { min: number; max: number }) => {
      emit('update:range', { min, max });
      emit('update:checkbox', { min, max });
    };
    const handleSetCustomRange = ({ min, max }) => {
      emit('update:range', { min, max });
    };

    const ceilToNearestMagnitude = (num: number): number => {
      const magnitude = Math.pow(10, Math.floor(Math.log10(num)));
      return Math.ceil(num / magnitude) * magnitude;
    };

    return {
      ActivePriceFilterTypes,
      handleSetCustomRange,
      ceilToNearestMagnitude,
      updateSliderRange
    };
  }
});
